// .env is converted to window.__config via Docker run.sh

export const CONTENT_URL = window.__config['FRECKLE_CONTENT_URL']
